import styled, { css } from 'styled-components';
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ displayState }) => css`
    position: relative;
    width: 127px;
    height: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid ${displayState?.color ? displayState.color : '#E3E3E3'};
    background: ${displayState?.color ? displayState.color : '#FFFFFF'};
    color: ${(displayState?.color === '#1DBD6B' || displayState?.color === '#117140') ? '#FFFFFF' : window?.settings?.secondary_color ?? '#04333b'};
    border-radius: 3px;
    font-size: 12px;
    padding: 8px;
    text-align: center;
    cursor: ${displayState?.color ? 'pointer' : ''};

    &:hover {
      border: 1px solid ${displayState?.color ? '#1DBD6B' : '#E3E3E3'};
    }
  `}
`;

export default Wrapper(template)